/***
 *
 *   LABEL STYLES
 *   The reference's dominant form label is `text-sm font-medium
 *   text-text-primary` — sentence case, not uppercase, and with no bottom
 *   margin of its own (the field wrapper's `space-y-1.5` provides the gap).
 *
 **********/

const Style = {
    base: 'relative block text-sm font-medium text-text-primary',
    required: `after:ml-1 after:font-semibold after:text-error after:content-['*']`,
};

export default Style;
